//import axios from "axios";
import { Navigation, Pagination, Lazy, A11y, Zoom } from 'swiper';
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';
import loadingAnimation from '../loading-animation.vue';
import ReviewStars from '../yotpo-reviews/review-stars/review-stars.vue';
import pdpError from '../../vue/pdp/pdp-error/pdp-err.vue';
import { delDiaPdp } from '../mixins/delDiaPdp';
import { pdp } from '../mixins/pdp';
import delDiaSlide from '../../vue/del-dia-slide/del-dia-slide.vue';
import { Colors } from '../enums/colors';
import { useMobile } from '../composables/useMobile';

export default {
  name: 'pdpDelDia',
  components: {
    Swiper,
    SwiperSlide,
    ReviewStars,
    pdpError,
    delDiaSlide,
    loadingAnimation,
  },
  props: ['productId', 'abVersion', 'lifestyleImgs'],
  mixins: [delDiaPdp, pdp],
  setup() {
    const { isMobile } = useMobile();
    const onSwiper = (swiper) => {};
    const onSlideChange = () => {
      //console.log('slide change');
    };
    return {
      isMobile,
      pagination: {
        clickable: true,
      },
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Lazy, A11y, Zoom],
    };
  },
  data() {
    return {
      Colors,
      isSurprise: false,
      accordionContent: [],
      whyYoullLoveIt: '',
      numReviews: 0,
      avgReview: 0,
      isActive: false,
      showModal: false,
      showDetailModal: false,
      activeDrawer: 0,
      activePin: null,
      isDrawerOpen: false,
      selectedVariant: {},
      showFullHeart: false,
      lifestyleImgs: [],
      error: false,
      loading: true,
      choiceProducts: [],
      ddProduct: {},
      soldout: false,
      backOrder: false,
      filteredColors: [],
      choicesCarouselKey: 0,
      minimized: true,
      uptContentWell: null,
      uptHandle: '',
      allpaInfo: [
        {
          title: 'The All-New Allpa 35L',
          intro: 'Our iconic adventure travel pack is better than ever with new features and a more ergonomic design.',
          imgHero:'https://cdn.shopify.com/s/files/1/0281/7544/files/Group_127135dd.jpg?v=1722287866',
          imgOne:'https://cdn.shopify.com/s/files/1/0281/7544/files/Frame_546435DD.jpg?v=1722287864',
          featureOne: 'Pass-through strap for roller bags',
          imgTwo:'https://cdn.shopify.com/s/files/1/0281/7544/files/Frame_546535DD.jpg?v=1722287863',
          featureTwo:'Stretch water bottle pocket',
          imgThree:'https://cdn.shopify.com/s/files/1/0281/7544/files/Frame_546635DD.jpg?v=1722287865',
          featureThree:'Padded mesh straps and back panel',
        },
        {
          title:'The All-New Allpa 42L',
          intro:'Our iconic adventure travel pack is better than ever with new features and a more ergonomic design.',
          imgHero:'https://cdn.shopify.com/s/files/1/0281/7544/files/Group_1280.jpg?v=1722289906',
          imgOne:'https://cdn.shopify.com/s/files/1/0281/7544/files/Left42DD.jpg?v=1722287864',
          featureOne: 'Pass-through strap for roller bags',
          imgTwo:'https://cdn.shopify.com/s/files/1/0281/7544/files/Mid42DD.jpg?v=1722287864',
          featureTwo:'Stretch water bottle pocket',
          imgThree:'https://cdn.shopify.com/s/files/1/0281/7544/files/Right42DD.jpg?v=1722287865',
          featureThree:'Padded mesh straps and back panel',
        },
        {
          title:'The All-New Allpa 28L',
          intro:'Our iconic adventure travel pack is better than ever with new features and a more ergonomic design.',
          imgHero:'https://cdn.shopify.com/s/files/1/0281/7544/files/Group_1279.jpg?v=1722289905',
          imgOne:'https://cdn.shopify.com/s/files/1/0281/7544/files/Frame_546428DD.jpg?v=1722287865',
          featureOne: 'Pass-through strap for roller bags',
          imgTwo:'https://cdn.shopify.com/s/files/1/0281/7544/files/Frame_546528DD.jpg?v=1722287863',
          featureTwo:'Stretch water bottle pocket',
          imgThree:'https://cdn.shopify.com/s/files/1/0281/7544/files/Frame_546628DD.jpg?v=1722287864',
          featureThree:'Padded mesh straps and back panel',
        },
      ],
    };
  },
  watch: {
    //adds 'viewed' tag to products after opening details modal
    // selectedVariant(newVariant, oldVariant) {
    //   oldVariant.viewed = true;
    // },

    //closes detail modal when user filters by color
    filteredColor(oldColor, newColor) {
      this.closeDetails();
    },
  },
  computed: {
    //filters choice items by color groups
    filteredChoices() {
      let selectedColors = [];
      //red colors
      if (this.filteredColors.includes(Colors.red)) {
        let redProducts = [...this.choiceProducts].filter(
          (x) =>
            x.color === Colors.red ||
            x.color === Colors.brightRed ||
            x.color === Colors.pink
        );
        this.choicesCarouselKey += 1;
        selectedColors = [...selectedColors, ...redProducts];
      }
      //orange colors
      if (this.filteredColors.includes(Colors.orange)) {
        let orangeProducts = [...this.choiceProducts].filter(
          (x) => x.color === Colors.orange
        );
        this.choicesCarouselKey += 1;
        selectedColors = [...selectedColors, ...orangeProducts];
      }
      //yellow colors
      if (this.filteredColors.includes(Colors.yellow)) {
        let yellowProducts = [...this.choiceProducts].filter(
          (x) => x.color === Colors.yellow || x.color === Colors.brightYellow
        );
        this.choicesCarouselKey += 1;
        selectedColors = [...selectedColors, ...yellowProducts];
      }
      //green colors
      if (this.filteredColors.includes(Colors.green)) {
        let greenProducts = [...this.choiceProducts].filter(
          (x) =>
            x.color === Colors.green ||
            x.color === Colors.darkGreen ||
            x.color === Colors.limeGreen
        );
        this.choicesCarouselKey += 1;
        selectedColors = [...selectedColors, ...greenProducts];
      }
      //blue colors
      if (this.filteredColors.includes(Colors.blue)) {
        let blueProducts = [...this.choiceProducts].filter(
          (x) =>
            x.color === Colors.blue ||
            x.color === Colors.darkBlue ||
            x.color === Colors.lightBlue ||
            x.color === Colors.teal
        );
        this.choicesCarouselKey += 1;
        selectedColors = [...selectedColors, ...blueProducts];
      }
      //purple
      if (this.filteredColors.includes(Colors.purple)) {
        let purpleProducts = [...this.choiceProducts].filter(
          (x) => x.color === Colors.purple
        );
        this.choicesCarouselKey += 1;
        selectedColors = [...selectedColors, ...purpleProducts];
      }
      //grey colors
      if (this.filteredColors.includes(Colors.gray)) {
        let grayProducts = [...this.choiceProducts].filter(
          (x) =>
            x.color === Colors.black ||
            x.color === Colors.white ||
            x.color === Colors.gray
        );
        this.choicesCarouselKey += 1;
        selectedColors = [...selectedColors, ...grayProducts];
      }
      //brown
      if (this.filteredColors.includes(Colors.brown)) {
        let brownProducts = [...this.choiceProducts].filter(
          (x) => x.color === Colors.brown
        );
        this.choicesCarouselKey += 1;
        selectedColors = [...selectedColors, ...brownProducts];
      }
      //view all
      if (this.filteredColors.length === 0) {
        this.choicesCarouselKey += 1;
        selectedColors = [...this.choiceProducts];
      }

      //filterByFavorites
      if (this.filteredColors.includes('favorites')) {
        let favProducts = [...this.choiceProducts].filter(
          (x) => x.favorite === true
        );
        this.choicesCarouselKey += 1;
        selectedColors = [...favProducts];
      }
      return selectedColors;
    },

    pinContent() {
      return this.ddProduct.imageMaps.filter((x) => x.pins && x.image);
    },
  },
  methods: {
    urlContains(str) {
      return window.location.href.includes(str);
    },
    getAllpaData() {
      if (this.urlContains('allpa-35')) return this.allpaInfo[0]; // Now correctly at index 0
      if (this.urlContains('allpa-42')) return this.allpaInfo[1]; // Moves down
      if (this.urlContains('allpa-28')) return this.allpaInfo[2]; // Moves down
      return null; // Default case
    },
    //activate the image mapper
    activatePin(pin) {
      // if this pin is already open, close it
      if (this.activePin === pin) {
        this.activePin = null;
      } else {
        // otherwise, open the drawer
        this.activePin = pin;
      }
    },
    rotateBtn() {
      var element = document.getElementById('refreshBtn');
      element.classList.add('rotate');
      setTimeout(function () {
        element.classList.remove('rotate');
      }, 500);
    },
    //open Modal
    openModal(img) {
      this.showModal = true;
      // go to correct image
      this.$refs.carousel.goTo(img);
    },
    //open Modal
    openDetailModal(img) {
      this.showDetailModal = true;
      // go to correct image
      //this.$refs.detailcarousel.goTo(img);
    },

    //open the Labels
    openLabel(index) {
      //console.log(index);
    },

    toggleSurpriseMe() {
      this.isSurprise = !this.isSurprise;
      this.selectedVariant = this.ddProduct;
      this.selectedVariantID = this.ddProduct.supriseMeVariantId;
      this.updateUrl();
    },
    getLifestyleImgs() {
      // get lifestyle images through API call
      let targetdomain = window.location.hostname.includes(
        'development.cotopaxi.com'
      )
        ? 'https://development-access-api.cotopaxi.com'
        : 'https://production-access-api.cotopaxi.com';
      axios
        .get(
          targetdomain +
            `/choice/getChoiceLifeStylePhotography/${this.productId}`
        )
        .then((response) => {
          const lifestyleImgs = response.data;
          if (lifestyleImgs) {
            this.lifestyleImgs = lifestyleImgs;
            console.log(this.lifestyleImgs);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    // get ab test sections data from access api
    getABTestSectionsData() {
      // get tab content through API call
      let targetdomain = window.location.hostname.includes(
        'development.cotopaxi.com'
      )
        ? 'https://development-access-api.cotopaxi.com'
        : 'https://production-access-api.cotopaxi.com';

      axios
        .get(
          targetdomain +
            `/section/abTestSectionsByShopifyProductId/${this.productId}`
        )
        .then((response) => {
          const sectionsData = response.data;

          // set whyYoullLoveIt and accordion data
          if (sectionsData.whyYoullLoveIt) {
            this.whyYoullLoveIt = sectionsData.whyYoullLoveIt[this.abVersion];
          }
          if (sectionsData.detailAccordion) {
            // hardcode version to be 'a' per ecomm team
            // dynamic version commented out below in case we switch back later
            this.accordionContent = sectionsData.detailAccordion['a'];

            // this.accordionContent = sectionsData.detailAccordion[this.abVersion]
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },

    // get bottom line info (total ratings, rating distribution, etc.)
    getBottomLine() {
      axios
        .get(
          `https://production-access-api.cotopaxi.com/yotpo/bottomLine/${this.productId}`
        )
        .then((res) => {
          if (res.data.bottomline) {
            // set average score
            this.avgReview =
              Math.round(Number(res.data.bottomline.average_score * 10)) / 10;

            this.numReviews = Number(res.data.bottomline.total_review);
          }
        })
        .catch((err) => {
          this.error = true;
          console.error(err);
        });
    },

    // get any active discounts for displaying the content well
    getDiscountData() {
      axios
        .get(
          `https://production-access-api.cotopaxi.com/discount/getContentWellByShopifyProductId/${this.productId}`
        )
        .then((response) => {
          if (response.data.contentWell) {
            this.uptContentWell = response.data.contentWell;
            this.uptHandle = response.data.handle || '';
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //scrolls to choices when color is selected
    goto(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo({ top: top, left: 0, behavior: 'smooth' });
    },

    // closeDetails() {
    //   this.minimized = true;
    //   this.selectedVariant = {};
    // },

    filterPrice(price) {
      let formattedPrice = price.toString(); // just in case data is passed through as integer
      if (!formattedPrice.includes('.00')) {
        // keeps decimal places if price does not end in .00
        formattedPrice = parseFloat(formattedPrice).toFixed(2);
      } else {
        formattedPrice = parseFloat(formattedPrice).toFixed(0); // drops $.00 if price is even number
      }
      return `$${formattedPrice}`;
    },

    toggleFavorite(product) {
      if (!product.favorite) {
        product.favorite = true;
      } else {
        product.favorite = !product.favorite;
      }
      console.log(this.choiceProducts);
    },

    filterFavorites() {
      if (this.filteredColors.includes('favorites')) {
        this.filteredColors = this.filteredColors.filter(
          (x) => x != 'favorites'
        );
      } else {
        this.filteredColors = ['favorites'];
      }
    },

    clearColorFilters() {
      this.filteredColors = [];
      this.showFullHeart = false;
    },

    //used to open the side cart
    openSlide() {
      // open the cart by attaching class
      let ddslideClassList = document.getElementById('ddslide').classList;
      if (!ddslideClassList.contains('ddslide-open')) {
        document.getElementById('ddslide').classList.add('ddslide-open');
      }
    },

    refreshGrid() {
      this.clearColorFilters();
      this.getChoiceProducts();
    },
  },

  beforeMount() {
    this.getBottomLine();
    this.getLifestyleImgs();
    this.getABTestSectionsData();
    this.getChoiceProducts();
    this.getDiscountData();
  },
};
